import React, { Component } from 'react';
import { Segment, Button, Container, Form, Radio } from 'semantic-ui-react';
import Page from '../components/Page';
import AccountProgress from '../components/AccountProgress';
class ButtonWidget extends Component {
	state = {
		countryCode: '',
		phoneNumber: '',
		radioGroup: 'both',
		whatsappMessage: "I'm interested in this product and I have a few questions. Can you help?",
		mobilePosition: 'right',
		desktopPosition: 'right',
		display: '95%',
		displayBox: '82%',
		buttonHeightMobile: '60',
		buttonHeightDesktop: '60',
		scriptCode: '',
		showDesktop: true,
		showMobile: false,
		requirementErrorCode: false,
		requirementErrorCodeMessage: '',
		requirementErrorPhone: false,
		requirementErrorPhoneMessage: '',
		design: 'small',
		whatsappText: 'Chat with Us',
	};

	handleChange = (e, { name, value }) => this.setState({ [name]: value });
	handleChangeImage = (value) => {
		this.setState({ design: value });
	};
	handleChangeCheckbox = (e, { name, value }) => {
		this.setState({ [name]: !this.state[name] });
	};
	handleChangeDisplay = (e, { name, value }) => {
		if (value === 'left') {
			this.setState({ [name]: value, display: '10%', displayBox: '10%' });
		} else {
			this.setState({ [name]: value, display: '95%', displayBox: '82%' });
		}
	};
	handleSubmit = () => {
		const { countryCode, phoneNumber, whatsappMessage, whatsappText } = this.state;
		if (!whatsappText) {
			return this.setState({ requirementErrorCode: true, requirementErrorCodeMessage: 'Enter widget text.' });
		}
		if (!countryCode) {
			return this.setState({ requirementErrorCode: true, requirementErrorCodeMessage: 'Enter country code.' });
		}
		if (!phoneNumber) {
			return this.setState({ requirementErrorPhone: true, requirementErrorPhoneMessage: 'Enter phone number.' });
		}
		if (!countryCode.match(/^(\+)?[0-9]*$/)) {
			return this.setState({ requirementErrorCode: true, requirementErrorCodeMessage: 'Enter country code.' });
		}
		if (!phoneNumber.match(/^[0-9]*$/)) {
			return this.setState({ requirementErrorPhone: true, requirementErrorPhoneMessage: 'Enter valid phone number.' });
		}

		let url = `https://api.whatsapp.com/send?phone=${countryCode}${phoneNumber}&text=${whatsappMessage}.`;

		this.setState({
			requirementErrorCode: false,
			requirementErrorPhone: false,
			requirementErrorCodeMessage: '',
			requirementErrorPhoneMessage: '',
			scriptCode: url,
		});
	};
	render() {
		const {
			countryCode,
			phoneNumber,
			whatsappMessage,
			radioGroup,
			mobilePosition,
			desktopPosition,
			scriptCode,
			showDesktop,
			showMobile,
			design,
			requirementErrorCode,
			requirementErrorPhone,
			requirementErrorCodeMessage,
			requirementErrorPhoneMessage,
			whatsappText,
		} = this.state;
		return (
			<Page header={<AccountProgress title="Button Settings" icon="whatsapp"></AccountProgress>}>
				<Page.Wrap>
					<Container>
						<Segment>
							<div style={{ textAlign: 'right' }}>
								<Button type="submit" primary onClick={this.handleSubmit}>
									Save
								</Button>
							</div>
							<div className="button-option">
								<h2>Basic Settings</h2>
								<Segment className="button-input">
									<Form>
										<Form.Group>
											<Form.Input
												label="Country Code"
												placeholder="Code"
												name="countryCode"
												value={countryCode}
												width={3}
												onChange={this.handleChange}
												error={
													requirementErrorCode
														? {
																content: requirementErrorCodeMessage,
														  }
														: false
												}
											/>
											<Form.Input
												label="Phone Number"
												placeholder="Phone Number"
												name="phoneNumber"
												value={phoneNumber}
												width={14}
												onChange={this.handleChange}
												error={
													requirementErrorPhone
														? {
																content: requirementErrorPhoneMessage,
														  }
														: false
												}
											/>
										</Form.Group>
									</Form>
								</Segment>
							</div>
							<hr></hr>
							<div className="button-option">
								<h2>Text & Design</h2>
								<Segment className="button-input">
									<Form>
										<Form.Group>
											<Form.Input
												label="WhatsApp Message Body"
												placeholder="I'm interested in this product and I have a few questions. Can you help?"
												name="whatsappMessage"
												value={whatsappMessage}
												width={16}
												onChange={this.handleChange}
											/>
										</Form.Group>
										<Form.Group>
											<Form.Checkbox
												inline
												checked={showDesktop}
												name="showDesktop"
												label="Show Message on Desktop"
												onChange={this.handleChangeCheckbox}
											/>
											<Form.Checkbox
												inline
												checked={showMobile}
												name="showMobile"
												label="Show Message on Mobile"
												onChange={this.handleChangeCheckbox}
											/>
										</Form.Group>

										<Form.Group>
											<div className="button-radios first" style={{ display: 'grid' }}>
												<Radio
													label="Small"
													name="design"
													value="small"
													checked={design === 'small'}
													onChange={this.handleChange}
													className="button-radio first"
												/>
												<img src="/whatsapp.svg" alt="" onClick={() => this.handleChangeImage('small')}></img>
											</div>
											<div className="button-radios" style={{ display: 'grid' }}>
												<Radio
													label="Large"
													name="design"
													value="large"
													checked={design === 'large'}
													onChange={this.handleChange}
													className="button-radio"
												/>
												<img src="/large.png" alt="" onClick={() => this.handleChangeImage('large')} style={{ width: '200px' }}></img>
											</div>
											<div className="button-radios" style={{ display: 'grid' }}>
												<Radio
													label="Large Green"
													name="design"
													value="large-green"
													checked={design === 'large-green'}
													onChange={this.handleChange}
													className="button-radio"
												/>
												<img
													src="/large-green.png"
													alt=""
													onClick={() => this.handleChangeImage('large-green')}
													style={{ width: '200px' }}
												></img>
											</div>
										</Form.Group>
										<Form.Group className={'widget-text-' + (design !== 'small' ? 'show' : 'hide')}>
											<Form.Input
												label="Widget Text"
												placeholder="Chat with Us"
												name="whatsappText"
												value={whatsappText}
												onChange={this.handleChange}
												error={
													requirementErrorCode
														? {
																content: requirementErrorCodeMessage,
														  }
														: false
												}
											/>
										</Form.Group>
									</Form>
								</Segment>
							</div>
							<hr></hr>
							<div className="button-option">
								<h2>Advanced Configuration</h2>
								<Segment className="button-input">
									<Form>
										<Form.Field className="formField">Button Display</Form.Field>
										<Form.Group className="button-display">
											<Radio
												label="Mobile+Desktop"
												name="radioGroup"
												value={'both'}
												checked={radioGroup === 'both'}
												onChange={this.handleChange}
												className="button-radio first"
											/>
											<Radio
												label="Desktop"
												name="radioGroup"
												value="desktop"
												checked={radioGroup === 'desktop'}
												onChange={this.handleChange}
												className="button-radio"
											/>
											<Radio
												label="Mobile"
												name="radioGroup"
												value="mobile"
												checked={radioGroup === 'mobile'}
												onChange={this.handleChange}
												className="button-radio"
											/>
										</Form.Group>
										<Form.Field className="formField">Chat Button Position (Mobile)</Form.Field>
										<Form.Group>
											<Radio
												label="Left"
												name="mobilePosition"
												value="left"
												checked={mobilePosition === 'left'}
												onChange={this.handleChange}
												style={{ marginLeft: '0.6rem' }}
											/>
											<Radio
												label="Right"
												name="mobilePosition"
												value="right"
												checked={mobilePosition === 'right'}
												onChange={this.handleChange}
												style={{ marginLeft: '1.6rem' }}
											/>
										</Form.Group>
										<Form.Field className="formField">Chat Button Position (Desktop)</Form.Field>
										<Form.Group>
											<Radio
												label="Left"
												name="desktopPosition"
												value="left"
												checked={desktopPosition === 'left'}
												onChange={this.handleChangeDisplay}
												style={{ marginLeft: '0.6rem' }}
											/>
											<Radio
												label="Right"
												name="desktopPosition"
												value="right"
												checked={desktopPosition === 'right'}
												onChange={this.handleChangeDisplay}
												style={{ marginLeft: '1.6rem' }}
											/>
										</Form.Group>
									</Form>
								</Segment>
							</div>
							<hr></hr>
							<div className="button-option">
								<h2>Script</h2>
								<Form className="button-input">
									<Form.Input placeholder="Code" name="scriptCode" value={scriptCode} readOnly onChange={this.handleChange} />
								</Form>
							</div>
						</Segment>
					</Container>

					<div
						className={
							'wa-float ' +
							radioGroup +
							(desktopPosition === 'left' ? ' left' : ' right') +
							(mobilePosition === 'left' ? ' mobileLeft' : ' mobileRight')
						}
					>
						<div className={'wa-popup' + (showDesktop ? ' showDesktop' : ' hiddenDesktop') + (showMobile ? ' showMobile' : ' hiddenMobile')}>
							<button className="close" id="close-chat">
								<img className="img" alt="" src="/close2.svg"></img>
							</button>
							<div className="content-whatsapp -top">
								<p>{whatsappMessage}</p>
							</div>
							<div className="content-whatsapp -bottom"></div>
						</div>
						<a
							className={'blantershow-chat ' + design}
							href={`https://api.whatsapp.com/send?phone=${countryCode}${phoneNumber}&text=${whatsappMessage}.`}
							target="_blank"
							without
							rel="noopener noreferrer"
						>
							<svg width="20" viewBox="0 0 24 24">
								<path
									fill="#eceff1"
									d="M20.5 3.4A12.1 12.1 0 0012 0 12 12 0 001.7 17.8L0 24l6.3-1.7c2.8 1.5 5 1.4 5.8 1.5a12 12 0 008.4-20.3z"
								/>
								<path
									fill="#4caf50"
									d="M12 21.8c-3.1 0-5.2-1.6-5.4-1.6l-3.7 1 1-3.7-.3-.4A9.9 9.9 0 012.1 12a10 10 0 0117-7 9.9 9.9 0 01-7 16.9z"
								/>
								<path
									fill="#fafafa"
									d="M17.5 14.3c-.3 0-1.8-.8-2-.9-.7-.2-.5 0-1.7 1.3-.1.2-.3.2-.6.1s-1.3-.5-2.4-1.5a9 9 0 01-1.7-2c-.3-.6.4-.6 1-1.7l-.1-.5-1-2.2c-.2-.6-.4-.5-.6-.5-.6 0-1 0-1.4.3-1.6 1.8-1.2 3.6.2 5.6 2.7 3.5 4.2 4.2 6.8 5 .7.3 1.4.3 1.9.2.6 0 1.7-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.2-.3-.3-.6-.4z"
								/>
							</svg>
							{whatsappText}
						</a>
					</div>
				</Page.Wrap>
			</Page>
		);
	}
}

export default ButtonWidget;
